import { useEffect } from "react";
import { createPortal } from "react-dom";

function Modal({ children }: { children: React.ReactElement | React.ReactNode }){
    useEffect(() => {
        const mainSection = document.getElementById('mainSection');
        const body = document.body;

        
        if(mainSection){
          mainSection.inert = true;
          body.setAttribute('aria-modal', 'true');
        }
    
        return () => {
          if(mainSection){
            mainSection.inert = false;
             body.removeAttribute('aria-modal');
          }
        }
    }, [])

    return createPortal(children, document.body)
}

export default Modal;